import { ListAlt } from "@mui/icons-material";
import theme from "theme";
import { ManagementCard } from "routes/lenses/lens/admin/management/ManagementCard";
import SBRCaseTable from "./CaseTable";
import { Card } from "@mui/material";

export default function SBRViewCasesDialog({ lensId }: { lensId: number }) {
  return (
    <div className="pt-4 h-full min-h-0">
      <Card className="flex flex-col h-full min-h-0">
        <div className="flex flex-col h-full min-h-0 p-4">
          <SBRCaseTable lensId={lensId} bulkActionsEnabled staticAssignees={[]} />
        </div>
      </Card>
    </div>
  );
}

export function ViewCases({ onClick }: { onClick: () => void }) {
  return (
    <ManagementCard
      title="View All Cases"
      onClick={onClick}
      Icon={ListAlt}
      color={theme.palette.primary.main}
      id="lens-admin-management-view-cases"
    />
  );
}
